import { cn } from '@/platform/lib/utils';

const FormGroup = ({
    inline = false,
    equal = false,
    className,
    children,
    ...props
}) => (
    <div
        className={cn(
            'gap-4 not-first:mt-6',
            inline
                ? 'grid grid-cols-1 items-start md:grid-cols-2 lg:grid-flow-col lg:grid-cols-none'
                : 'flex flex-col',
            inline && equal && 'lg:auto-cols-fr',
            className
        )}
        {...props}
    >
        {children}
    </div>
);

export default FormGroup;
